// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"./variables.css\"","BASE_COLOR":"#0c8eff"};